import { Routes, Route, Navigate } from 'react-router-dom'

import { FundingRoundsScreen, /* UnlocksScreen, */ RFQScreen } from './data-room'

const DataRoomScreen = () => {

  return (
    <div className="min-h-screen bg-[var(--background)]">
      <Routes>
        <Route path="/" element={<Navigate to="/data-room/funding-rounds" replace />} />
        <Route path="/funding-rounds/*" element={<FundingRoundsScreen />} />
        {/* <Route path="/unlocks/*" element={<UnlocksScreen />} /> */}
        <Route path="/rfq" element={<RFQScreen />} />
      </Routes>
    </div>
  )
}

export default DataRoomScreen 